export function nextAvailableName(
  existingNames: Set<string>,
  prefix: string,
  increment = 1
): string {
  let n = increment;
  while (existingNames.has(`${prefix}${n}`)) n += increment;
  return `${prefix}${n}`;
}
